import { useEffect, useRef } from 'react';

/*
 Use to check if "currentValue" equals "to" at least once while changing
 */
export const useWasTurnedTo = (
  currentValue: unknown,
  to: unknown = true,
): boolean => {
  const ref = useRef<boolean>(to === currentValue);

  useEffect(() => {
    if (to === currentValue) {
      ref.current = true;
    }
  }, [currentValue, to]);

  return ref.current;
};
